import type { RootState, Cart } from 'core';
import type { ConsumerPrice, ResellerPrice } from 'ui/components';

import { VWOAnalyticsService } from 'core/services';
import { isTestABVersion } from 'core/use-cases/app/helpers';
import { getValueTag } from 'ui/containers/ContentBuilder/widgets/utilities/tag';

import type { TItemEvent } from '../../@types';
import { TRACKING_CURRENCY } from '../../const';
import { getItemBadges } from '../../helpers';
import { generateItemEvent } from '../../helpers/generateItemEvent';

import { cartItemDelete } from './cartItemDelete';
import { getProduct } from '../../helpers/getters';

type Item = Cart['data']['items'][number];

export const cartItemUpdate = (action: any, prevState: RootState) => {
  const eventTypes = { remove: 'remove_from_cart', add: 'add_to_cart' };

  const {
    meta,
    payload: { items = [], totalNum = 0 },
  } = action;
  const { productCode } = meta.payload;

  const itemChanges = generateItemEvent({ action, prevState, productCode, items }) as TItemEvent;

  if (itemChanges.type === eventTypes.remove) {
    return cartItemDelete(action, prevState);
  }

  const product = items?.find((item: Item) => item.productCode === productCode) as Item;

  const productOnList = getProduct(prevState, productCode);
  const badges = getItemBadges(productOnList?.tags, prevState);
  const resellerPrice = productOnList?.priceWrapper?.resellerPrice as unknown as ResellerPrice;
  const consumerPrice = productOnList?.priceWrapper?.consumerPrice as unknown as ConsumerPrice;
  const discount = getValueTag(resellerPrice, consumerPrice, true);

  if (itemChanges.type === eventTypes.add && isTestABVersion()) {
    VWOAnalyticsService?.dispatchVWOEvent(itemChanges.type);
  }

  return {
    event: itemChanges.type,
    ecommerce: {
      currency: TRACKING_CURRENCY,
      value: totalNum,
      items: [
        {
          item_id: product?.productCode,
          item_name: product?.name,
          affiliation: productOnList?.tags?.length ? 'promocao' : 'padrao',
          discount,
          index: product?.productIndex || '',
          item_brand: productOnList?.brand || '',
          item_category: productOnList?.category || productOnList?.department || '',
          item_list_name: meta.payload?.itemListName || product?.itemListName || '',
          price: product?.priceNum || '',
          quantity: product?.quantity || 1,
          cd_item_tag: badges || '',
        },
      ],
    },
  };
};
